import moment from 'moment';

function toISODateFormatter(value: any) {
    if (value) {
        return moment(String(value)).format('YYYY-MM-DD');
    } else {
        return '';
    }
}

export default toISODateFormatter;


